import { PaymentServiceRecord, PaymentTypeRecord } from './payments.types';

export const BANK_QR_PAYMENT_CODES = [1, 3, 4, 14, 15] as const;

export function compatiblePaymentService(type: Pick<PaymentTypeRecord, 'id' | 'fiscal_code'> | undefined, service: PaymentServiceRecord, currency: string | null): boolean {
  if (service.x_data?.integration !== 'bank_qr') return true;
  if (!type || currency && currency !== 'UAH') return false;
  return type.fiscal_code == null ? type.id === service.x_data.settings?.payment_type_id
    : (BANK_QR_PAYMENT_CODES as readonly number[]).includes(type.fiscal_code);
}
